import { z } from 'zod'
import { oc } from '@orpc/contract'

const enrichedRowSchema = z.object({
  name: z.string(),
  address: z.string().optional(),
  phone: z.string().optional(),
  fax: z.string().optional(),
  source: z.enum(['npi', 'ai', 'none']),
  sources: z
    .object({
      address: z.string().optional(),
      phone: z.string().optional(),
      fax: z.string().optional(),
    })
    .optional(),
})

const enrichmentSchema = z.object({
  providers: z.array(enrichedRowSchema),
  locations: z.array(enrichedRowSchema),
  generatedAt: z.string(),
  status: z.enum(['running', 'complete', 'failed']),
  progress: z.object({ completed: z.number(), total: z.number() }).optional(),
  providersStale: z.boolean().optional(),
})

/**
 * Re-runs ONLY the provider lookup (deterministic NPI) and leaves the locations
 * as they are — the locations pass is the AI research that makes a full rerun
 * expensive (PD-1293). Separate from `/run` so refreshing providers after a new
 * one appears never implies paying for that.
 *
 * Returns `null` when the patient has no enrichment yet: there is nothing to
 * refresh, and producing a providers-only enrichment from nothing would render as
 * an Enriched view with no locations.
 */
export const refreshRecordLocatorProviders = oc
  .route({ method: 'POST', path: '/v2/patients/{patientId}/record-locator/refresh-providers' })
  .input(z.object({ patientId: z.string() }))
  .output(enrichmentSchema.nullable())
